import { Dropdown, Menu } from "antd";
import Table, { ColumnsType } from "antd/es/table";
import { Key, useState } from "react";
import { AsynPermissions } from "./AsynPermissions";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { hasPermission } from "utils/hasPermission";
import { useGetRoles } from "../hooks/useGetRoles";
import { AuthorizationGuard, AuthorizationRole } from "../types";
import { AssignRole } from "./AssignRole";

interface RolesTableProps {
  guardName: AuthorizationGuard;
}

export const RolesTable = ({ guardName }: RolesTableProps) => {
  const { data, isLoading: rolesDataLoading } = useGetRoles({ guardName });
  const [selectedRowKeys, setSelectedRowKeys] = useState<Key[]>([]);
  const [role, setRole] = useState<AuthorizationRole | null>(null);
  const [permissionsModal, setPermissionsModal] = useState(false);
  const [assignRoleModal, setAssignRoleModal] = useState(false);
  const { userInfo } = useGetUserInfo();


  const hasPermissionFor = (...permissionNames: string[]): boolean => {
    return permissionNames.some(permissionName =>
      hasPermission(userInfo, permissionName)
    );
  };

  const columns: ColumnsType<AuthorizationRole> = [
    {
      title: "Id",
      dataIndex: "id",
    },
    {
      title: "Name",
      dataIndex: "name",
      render: (_, val) => (
        <p
          className="font-medium text-primary"
        >
          {val.name}
        </p>
      ),
    },
    {
      title: "Permissions",
      dataIndex: "permissions",
      render: (_, val) => (
        <div className="font-medium text-primary">
          {val.permissions.length}
        </div>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",

      render: (_, val) => (
        <div>
          {
            hasPermissionFor('Manage Admin users') &&
            <Dropdown
              trigger={["click"]}
              disabled={selectedRowKeys.length > 0}
              overlay={
                <Menu>
                  <Menu.Item key="1" onClick={() => {
                    setRole(val);
                    setPermissionsModal(true);
                  }}>
                    Assign Permissions
                  </Menu.Item>
                  <Menu.Item key="2" onClick={() => {
                    setRole(val);
                    setAssignRoleModal(true);
                  }}>
                    Assign Role to User
                  </Menu.Item>
                </Menu>
              }
            >
              <i className="ri-more-2-fill text-lg cursor-pointer"></i>
            </Dropdown>
          }
        </div>
      ),
    },
  ];

  return (
    <div>
      <AsynPermissions
        open={permissionsModal}
        guardName={guardName}
        role={role}
        handleClose={() => setPermissionsModal(false)}
      />
      <AssignRole
        open={assignRoleModal}
        guardName={guardName}
        initialRole={role}
        handleClose={() => setAssignRoleModal(false)}
      />
      <Table
        className="bg-white rounded-md shadow border mt-8"
        columns={columns}
        rowKey="id"
        dataSource={data?.data}
        rowSelection={{
          selectedRowKeys,
          onChange: setSelectedRowKeys,
        }}
        scroll={{ x: 550 }}
        loading={rolesDataLoading}
      />
    </div>
  );
};
